import axios from 'axios';

import {
  getPhotoInfo,
} from './actions';

import conf from '../../config/config.js';
import common from '../common/operations';

/**
 * @typedef PhotoRegistlationInfo 写真登録情報
 * @property {string} contractDntId 契約電柱ID
 * @property {string} transitionSrcId 遷移元画面の画面番号
 * @property {boolean} [readOnly] 読取専用で表示する場合trueを設定。省略時はfalse扱い
 * @property {boolean} [hasCommunicationLine] 通信引込線の有無
 * @property {boolean} [hasNewCopperPipes] 電柱への立上り銅管の新設有無
 * @property {'mae'} [suffix] 撤去 施工前の写真登録の場合は'mae'を指定
 * @property {string} [sekoMaeDntId] 施工前の契約電柱ID。竣工写真登録画面で施工前の電柱写真を表示する場合に指定
 * @property {'mae'} [sekoMaeSuffix] 施工前のサフィックス。竣工写真登録画面で施工前の電柱写真を表示する場合に指定
 */

/**
 * 写真アップロード。
 * @param {object} dntInfo 契約電柱情報
 * @param {string} suffix サフィックス。アップロード先ディレクトリ名の契約電柱IDの後に付加
 * @param {Object.<string, UploadFileInfo[]>} uploadImages 画像情報一覧
 * @param {Object.<string, UploadFileInfo[]>} deleteImages 削除画像情報一覧
 * @return {function}
 */
const doUploadPhoto = (dntInfo, suffix, uploadImages, deleteImages) => {
  console.log('写真 アップロード...');

  return async (dispatch, getState) => {
    const {auth} = getState();

    // S3のバケットに一時アップロード
    const uploadResult =
      await common.doUploadToS3Common(uploadImages, getState, dispatch);

    // 削除したファイルのキー一覧を生成
    const deleteFileKeys = createDeleteFileKeys(deleteImages);

    // 写真登録APIを実行する
    const body = {
      orderId: dntInfo.Order__r.Id,
      contractDntId: dntInfo.Id,
      suffix: suffix,
      fileInfo: {
        uuid: uploadResult.uuid,
        uploadFiles: uploadResult.uploadFiles,
        deleteFileKeys: deleteFileKeys,
      },
    };

    // 一時アップロードしたファイルを正式な場所へ格納
    // TODO: 備考を登録していない
    const ret = await axios.post(conf.API_URL + 'Photo/regist', body, {
      headers: {Authorization: auth.loginInfo.idToken},
    });

    // 一時アップロードが失敗でファイル登録成功時、エラー情報置き換え
    common.doCheckS3UploadResult(uploadResult, ret);

    return ret;
  };
};

/**
 * 削除ファイルのキー一覧生成。
 * @param {Object.<string, UploadFileInfo[]>} deleteImages
 * @return {string[]} キー一覧
 */
function createDeleteFileKeys(deleteImages) {
  const deleteFiles = [];

  for (const photoType of Object.keys(deleteImages)) {
    for (const image of deleteImages[photoType]) {
      const key = image.ContentDocumentId;
      if (key == null) {
        // deleteImagesにContentDocumentId未設定の場合、未アップロードなので除外
        continue;
      }

      deleteFiles.push(key);
    }
  }

  return deleteFiles;
}

/**
 * 写真情報 取得。
 * @param {GetDntInfo[]} conditions 検索条件一覧
 * @param {boolean} getSignedUrl Base64形式ではなく、S3の署名付きURLとして画像を取得する場合はtrue
 * @return {function}
 */
const doGetPhotoInfo = (conditions, getSignedUrl) => {
  console.log('写真 取得...');

  return async (dispatch, getState) => {
    const {auth} = getState();

    const body = {
      conditions,
      getSignedUrl,
    };

    const ret = await axios.post(conf.API_URL + 'Photo/get', body, {
      headers: {Authorization: auth.loginInfo.idToken},
    });

    const data = ret.data.body.data ? ret.data.body.data : null;
    dispatch(getPhotoInfo(data));
    return ret;
  };
};

/**
 * 写真情報 破棄。
 * @return {function}
 */
const doClearPhotoInfo = () => {
  console.log('写真 破棄...');
  return async (dispatch, getState) => {
    dispatch(getPhotoInfo(null));
  };
};

/**
 * 写真削除。
 * @param {string} orderId 申込ID
 * @param {string} contractDntId 契約電柱 レコードID 省略時は申込に紐づく写真を全て削除
 * @return {function}
 */
const doDeletePhoto = (orderId, contractDntId = null) => {
  console.log('写真 削除...');

  return async (dispatch, getState) => {
    const {auth} = getState();

    const body = {
      orderId: orderId,
      contractDntId: contractDntId,
    };
    console.log({body});
    const ret = await axios.post(conf.API_URL + 'Photo/delete', body, {
      headers: {Authorization: auth.loginInfo.idToken},
    });

    return ret;
  };
};

/**
 * 写真登録有無判定。
 * @param {string} contractDntId 契約電柱 レコードID
 * @param {string} suffix サフィックス
 * @return {function}
 */
const doExistsPhoto = (contractDntId, suffix) => {
  console.log('写真 写真登録有無判定...');

  return async (dispatch, getState) => {
    const {auth} = getState();

    const body = {
      contractDntId: contractDntId,
      suffix: suffix,
    };

    console.log(body);
    const ret = await axios.post(conf.API_URL + 'Photo/exists', body, {
      headers: {Authorization: auth.loginInfo.idToken},
    });

    return ret;
  };
};

export default {
  doUploadPhoto,
  doGetPhotoInfo,
  doClearPhotoInfo,
  doDeletePhoto,
  doExistsPhoto,
};
